import { render, staticRenderFns } from "./ChapterModal.vue?vue&type=template&id=017d9f90"
import script from "./ChapterModal.vue?vue&type=script&lang=js"
export * from "./ChapterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports